import { apiClient } from './client'
import type { ApiResponse, AuthResponse, LoginRequest, User } from '@/types/api'

export const authApi = {
  login: async (data: LoginRequest): Promise<AuthResponse> => {
    const response = await apiClient.post<ApiResponse<AuthResponse>>('/auth/login', data)
    if (!response.data.data) {
      throw new Error('Login failed')
    }
    return response.data.data
  },

  logout: async (): Promise<void> => {
    await apiClient.post('/auth/logout')
  },

  me: () =>
    apiClient.get<ApiResponse<User>>('/auth/me'),

  refresh: (refreshToken: string) =>
    apiClient.post<ApiResponse<AuthResponse>>('/auth/refresh', { refreshToken }),
}





















